import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AppRouter } from 'app/router/app-router';
import styles from 'app/styles/app.module.scss';
import { GlobalGuard } from 'app/router/guards/global-guard';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  // <React.StrictMode>
  <div className={styles.background__color}>
    <GlobalGuard>
      <RouterProvider router={AppRouter} />
    </GlobalGuard>
  </div>
  // </React.StrictMode>
);
